import MetricBase from "models/metrics/MetricBase";
import PerformanceGroup from "models/groups/PerformanceGroup";
import PercentUnit from "models/metrics/unit/PercentUnit";
import i18n from "i18next";

class MetricMeet extends MetricBase {
    constructor() {
        super({
            field: "metric_meet_ratio",
            defaultVisibility: true,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.trivago.meet.chartName"),
            serieLabel: i18n.t("metrics.trivago.meet.serieLabel"),
            tooltip: i18n.t("metrics.trivago.meet.tooltip"),
            group: new PerformanceGroup(),
        });
    }
}

export default MetricMeet;
